//@ts-nocheck
import React, { useState } from "react";
import styles from "./InfoBubble.module.scss";
import Svg from "../../Svg/Svg";

function InfoBubble(props) {
	const { description } = props;

	const [hover, setHover] = useState(false);

	function onHover(e) {
		e.preventDefault();
		setHover(true);
	}

	function offHover(e) {
		e.preventDefault();
		setHover(false);
	}

	function handleClick(e) {
		e.preventDefault();
		if (hover) {
			setHover(false);
		} else {
			setHover(true);
		}
	}

	return (
		<div className={styles.info_bubble_wrapper} onMouseEnter={(e) => onHover(e)} onMouseLeave={(e) => offHover(e)} onClick={handleClick}>
			<div className={styles.bubble_icon}>
				<Svg icon="INFO_BUBBLE" cssClass={"info_bubble"} />
			</div>
			<p className={styles.bubble_popup}>{description}</p>
		</div>
	);
}

export default InfoBubble;
